/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomerOrder } from '../models/customer-order';
import { ordersCancelOrderRetrieve } from '../fn/orders/orders-cancel-order-retrieve';
import { OrdersCancelOrderRetrieve$Params } from '../fn/orders/orders-cancel-order-retrieve';
import { ordersConfirmDeliveryCreate } from '../fn/orders/orders-confirm-delivery-create';
import { OrdersConfirmDeliveryCreate$Params } from '../fn/orders/orders-confirm-delivery-create';
import { ordersList } from '../fn/orders/orders-list';
import { OrdersList$Params } from '../fn/orders/orders-list';
import { ordersPartialUpdate } from '../fn/orders/orders-partial-update';
import { OrdersPartialUpdate$Params } from '../fn/orders/orders-partial-update';
import { ordersRetrieve } from '../fn/orders/orders-retrieve';
import { OrdersRetrieve$Params } from '../fn/orders/orders-retrieve';
import { ordersUpdate } from '../fn/orders/orders-update';
import { OrdersUpdate$Params } from '../fn/orders/orders-update';
import { PaginatedCustomerOrderList } from '../models/paginated-customer-order-list';

@Injectable({ providedIn: 'root' })
export class OrdersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ordersList()` */
  static readonly OrdersListPath = '/msp/api/orders/';

  /**
   * Allows retrieving and updating Orders where the authenticated user is a Customer.
   * Creation and deletion of Orders is done by the server or by admins.
   * The order_products attribute is read-only.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordersList()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersList$Response(params?: OrdersList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedCustomerOrderList>> {
    return ordersList(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows retrieving and updating Orders where the authenticated user is a Customer.
   * Creation and deletion of Orders is done by the server or by admins.
   * The order_products attribute is read-only.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordersList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersList(params?: OrdersList$Params, context?: HttpContext): Observable<PaginatedCustomerOrderList> {
    return this.ordersList$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedCustomerOrderList>): PaginatedCustomerOrderList => r.body)
    );
  }

  /** Path part for operation `ordersRetrieve()` */
  static readonly OrdersRetrievePath = '/msp/api/orders/{id}/';

  /**
   * Allows retrieving and updating Orders where the authenticated user is a Customer.
   * Creation and deletion of Orders is done by the server or by admins.
   * The order_products attribute is read-only.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordersRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersRetrieve$Response(params: OrdersRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerOrder>> {
    return ordersRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows retrieving and updating Orders where the authenticated user is a Customer.
   * Creation and deletion of Orders is done by the server or by admins.
   * The order_products attribute is read-only.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordersRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersRetrieve(params: OrdersRetrieve$Params, context?: HttpContext): Observable<CustomerOrder> {
    return this.ordersRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerOrder>): CustomerOrder => r.body)
    );
  }

  /** Path part for operation `ordersUpdate()` */
  static readonly OrdersUpdatePath = '/msp/api/orders/{id}/';

  /**
   * Allows retrieving and updating Orders where the authenticated user is a Customer.
   * Creation and deletion of Orders is done by the server or by admins.
   * The order_products attribute is read-only.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordersUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordersUpdate$Response(params: OrdersUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerOrder>> {
    return ordersUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows retrieving and updating Orders where the authenticated user is a Customer.
   * Creation and deletion of Orders is done by the server or by admins.
   * The order_products attribute is read-only.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordersUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordersUpdate(params: OrdersUpdate$Params, context?: HttpContext): Observable<CustomerOrder> {
    return this.ordersUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerOrder>): CustomerOrder => r.body)
    );
  }

  /** Path part for operation `ordersPartialUpdate()` */
  static readonly OrdersPartialUpdatePath = '/msp/api/orders/{id}/';

  /**
   * Allows retrieving and updating Orders where the authenticated user is a Customer.
   * Creation and deletion of Orders is done by the server or by admins.
   * The order_products attribute is read-only.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordersPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordersPartialUpdate$Response(params: OrdersPartialUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerOrder>> {
    return ordersPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Allows retrieving and updating Orders where the authenticated user is a Customer.
   * Creation and deletion of Orders is done by the server or by admins.
   * The order_products attribute is read-only.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordersPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordersPartialUpdate(params: OrdersPartialUpdate$Params, context?: HttpContext): Observable<CustomerOrder> {
    return this.ordersPartialUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerOrder>): CustomerOrder => r.body)
    );
  }

  /** Path part for operation `ordersCancelOrderRetrieve()` */
  static readonly OrdersCancelOrderRetrievePath = '/msp/api/orders/{id}/cancel_order/';

  /**
   * Customer endpoint for cancelling an Order with all its products.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordersCancelOrderRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersCancelOrderRetrieve$Response(params: OrdersCancelOrderRetrieve$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerOrder>> {
    return ordersCancelOrderRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Customer endpoint for cancelling an Order with all its products.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordersCancelOrderRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersCancelOrderRetrieve(params: OrdersCancelOrderRetrieve$Params, context?: HttpContext): Observable<CustomerOrder> {
    return this.ordersCancelOrderRetrieve$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerOrder>): CustomerOrder => r.body)
    );
  }

  /** Path part for operation `ordersConfirmDeliveryCreate()` */
  static readonly OrdersConfirmDeliveryCreatePath = '/msp/api/orders/{id}/confirm_delivery/';

  /**
   * Sets 'is_delivery_confirmed' on one or more OrderProducts in the Order,
   * AND sets the Order's status to COMPLETE.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordersConfirmDeliveryCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordersConfirmDeliveryCreate$Response(params: OrdersConfirmDeliveryCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerOrder>> {
    return ordersConfirmDeliveryCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Sets 'is_delivery_confirmed' on one or more OrderProducts in the Order,
   * AND sets the Order's status to COMPLETE.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordersConfirmDeliveryCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordersConfirmDeliveryCreate(params: OrdersConfirmDeliveryCreate$Params, context?: HttpContext): Observable<CustomerOrder> {
    return this.ordersConfirmDeliveryCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerOrder>): CustomerOrder => r.body)
    );
  }

}
